module.exports = __webpack_public_path__ + "static/media/importFlybook4.cd5b999f.png";